import Button from '../atoms/Button'
import {
  isWalletLinkedOtherComplexRegistrationError,
  useConnectWallet,
} from '@verisart/nft/src'
import Dialog from '../atoms/Dialog'
import { useWallet } from 'src/context/wallet'
import { useQueryClient } from '@tanstack/react-query'
import { useMemo } from 'react'

const MoveWalletDialog: React.FC = () => {
  const queryClient = useQueryClient()

  const { claimWallet, error: connectError } = useWallet()
  const { disconnect } = useConnectWallet()

  const error = useMemo(() => {
    if (
      connectError !== undefined &&
      isWalletLinkedOtherComplexRegistrationError(connectError)
    ) {
      return connectError
    }
    return undefined
  }, [connectError])

  return (
    <Dialog show={error !== undefined}>
      <div className={'ver-w-80 ver-flex ver-flex-col ver-gap-10'}>
        <div className="ver-w-full ver-center">
          <p>{error?.misc.detailedMessage}</p>
        </div>
        <div className="ver-w-full ver-flex ver-flex-col ver-gap-4">
          <Button
            onClick={async (e) => {
              e.stopPropagation()
              try {
                if (error === undefined) {
                  return
                }

                await claimWallet({
                  ...error.misc.signedChallenge,
                  moveExisting: true,
                })
                await queryClient.invalidateQueries({
                  queryKey: ['account'],
                })
              } catch (_) {
                console.error('Something went wrong')
              }
            }}
          >
            Move Wallet
          </Button>
          <Button secondary onClick={() => disconnect()}>
            Cancel
          </Button>
        </div>
      </div>
    </Dialog>
  )
}

export default MoveWalletDialog
